<template>
    <div ref="lastArticlesHeader" class="lastArticlesContainer">
      <v-toolbar class="categoriesHeader" elevation="0"
      >
        <v-icon @click="goBack">
          mdi-chevron-left
        </v-icon>


        <v-toolbar-title class="pageTitle">
          Mein Konto
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="headerDivider"/>
    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper">

      <v-snackbar class="mismatchedPwBar" top v-model="passwordMismatch">
        <Span>Deine eingegebenen Passwörter stimmen nicht überein.</Span>
      </v-snackbar>

    <v-card class="articleCard__details">
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  rounded
                  v-model="firstname"
                  outlined
                  dense
                  label="Vorname"
                  placeholder="Vorname"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                  rounded
                  v-model="lastname"
                  outlined
                  dense
                  label="Nachname"
                  placeholder="Nachname"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                  rounded
                  v-model="userId"
                  outlined
                  disabled
                  dense
                  label="Benutzer- ID"
                  placeholder="Benutzer- ID"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                  rounded
                  v-model="customerId"
                  outlined
                  disabled
                  dense
                  label="Kunden- ID"
                  placeholder="Kunden- ID"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-card-actions class="cardActionsRight">
                <v-btn class="changePasswordBtn"
                       @click="editPassword"
                >
                  <span class="textSize__14">Passwort ändern</span>
                </v-btn>

                <v-btn class="saveChangesBtn"
                       :disabled="changePassword"
                >
                  <span class="textSize__14">Sichern</span>
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

            <div v-if="changePassword">
              <v-divider/>
              <v-col cols="12">
                <v-text-field
                    rounded
                    v-model="password"
                    type="password"
                    outlined
                    dense
                    :disabled="!changePassword"
                    label="Altes Passwort eingeben"
                    placeholder="Altes Passwort"
                ></v-text-field>
              </v-col>

              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          rounded
                          v-model="passwordNew"
                          type="password"
                          outlined
                          dense
                          :disabled="!changePassword"
                          label="Neues Passwort"
                          placeholder="Neues Passwort"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                          rounded
                          v-model="passwordRepeat"
                          type="password"
                          outlined
                          dense
                          :disabled="!changePassword"
                          label="Passwort wiederholen"
                          placeholder="Passwort wiederholen"
                      ></v-text-field>
                      <v-card-actions class="cardActionsRight">
                        <v-btn class="savePasswordBtn"
                               @click="savePassword"
                        >
                      <span class="textSize__14">
                        Passwort sichern
                      </span>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </div>
    </v-card>
      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import axios from 'axios'
import router from "@/router";

export default {
  name: "profile",
  data:() => {
    return {
      firstname: '',
      lastname: '',
      userId: '',
      customerId: '',
      password: '',
      passwordNew: '',
      passwordRepeat: '',

      changePassword: false,
      passwordMismatch: false
    }
  },

  methods: {
    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility'
    }),

    goBack() {
      router.go(-1)
    },

    editPassword() {
      this.changePassword = !this.changePassword
    },

    savePassword() {

      if(this.passwordNew === this.passwordRepeat) {
        axios.post('/api/changePassword', this.credentials)
            .then(() => {
              this.password= ''
              this.passwordNew= ''
              this.passwordRepeat= ''

              // add notification text

              this.changePassword = false
            })
      }
      else {
        this.passwordMismatch = true
      }
    }
  },

  computed: {
    credentials() {
      const {password} = this
      const {passwordNew} = this
      const {passwordRepeat} = this
      return {
        password,
        passwordNew,
        passwordRepeat
      }
    },
  },

  created() {
    this.setHeaderVisibility(false)

    axios.get('/api/getUserData')
        .then((response) => {
        this.firstname = response.data.firstName
        this.lastname = response.data.lastName
        this.userId = response.data.uid
          this.customerId = response.data.customerId
    })
  }
}
</script>

<style scoped>
  .bottomPad {
    padding-bottom: 15px!important;
  }
</style>
